import React, { useState, useEffect, useContext } from "react";
import { ProjectContext } from "../../App";
import api from "../../api/axiosConfig";

const EventSettings = () => {
  const { isNavBarOpen } = useContext(ProjectContext);
  const [events, setEvents] = useState([]);
  const [modules, setModules] = useState([]);
  const [newEvent, setNewEvent] = useState({
    module_table: "",
    action: "",
    subject: "",
    body: "",
    from_email: "",
    to_emails: "",
    enabled: true,
  });
  const [eventCreateDial, setEventCreateDial] = useState(false);

  useEffect(() => {
    fetchEvents();
    fetchModules();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await api.get("/api/events");
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const fetchModules = async () => {
    const response = await api.get("/api/modules");
    setModules(response.data);
  };

  const handleCreateEvent = async () => {
    if (!newEvent.module_table || !newEvent.action) {
      alert("Please fill in all required fields.");
      return;
    }
    try {
      await api.post("/api/events", newEvent);
      fetchEvents();
      setNewEvent({
        module_table: "",
        action: "",
        subject: "",
        body: "",
        from_email: "",
        to_emails: "",
        enabled: true,
      });
      setEventCreateDial(false);
    } catch (error) {
      console.error("Error creating event:", error);
    }
  };

  const toggleEventEnabled = async (event) => {
    try {
      await api.put(`/api/events/${event.id}/enable`, {
        enabled: !event.enabled,
      });
      fetchEvents(); // Refresh after a successful update
    } catch (error) {
      console.error("Error updating event:", error);
    }
  };

  const updateEmailDetails = async (eventId, updatedFields) => {
    try {
      await api.put(`/api/events/update/${eventId}`, updatedFields);
      fetchEvents(); // Refresh after a successful update
    } catch (error) {
      console.error("Error updating event:", error);
    }
  };

  return (
    <div>
      {/* Add Event Form */}
      <div>
        <button
          className="add-event-btn"
          onClick={() => setEventCreateDial(true)}
        >
          Create New Event
        </button>
      </div>

      {/* Existing Events List */}
      <div
        className={
          isNavBarOpen ? "event-table-wrapper" : "event-table-wrapper-close"
        }
      >
        <table className="event-settings-table">
          <thead style={{ position: "sticky", zIndex: "2" }}>
            <tr>
              <th>S.No</th>
              <th>Module</th>
              <th>Action</th>
              <th>Subject</th>
              <th>Body</th>
              <th>Enabled</th>
              <th style={{ width: "67%" }}></th>
            </tr>
          </thead>
          <tbody>
            {events.map((event, index) => (
              <tr key={event.id}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>

                <td>
                  {event.module_table.charAt(0).toUpperCase() +
                    event.module_table.slice(1)}
                </td>
                <td>
                  {event.action.charAt(0).toUpperCase() + event.action.slice(1)}
                </td>
                <td style={{ padding: "0" }}>
                  <input
                    className="event-setting-subject"
                    onChange={(e) =>
                      setEvents((prevEvents) =>
                        prevEvents.map((ev) =>
                          ev.id === event.id
                            ? { ...ev, subject: e.target.value }
                            : ev
                        )
                      )
                    }
                    onBlur={(e) =>
                      updateEmailDetails(event.id, { subject: e.target.value })
                    }
                    value={event.subject}
                  />
                </td>
                <td style={{ padding: "0" }}>
                  <textarea
                    className="event-setting-body"
                    value={event.body}
                    onChange={(e) =>
                      setEvents((prevEvents) =>
                        prevEvents.map((ev) =>
                          ev.id === event.id
                            ? { ...ev, body: e.target.value }
                            : ev
                        )
                      )
                    }
                    onBlur={(e) =>
                      updateEmailDetails(event.id, { body: e.target.value })
                    }
                  />
                </td>
                <td style={{ textAlign: "center" }}>
                  <input
                    style={{ cursor: "pointer" }}
                    type="checkbox"
                    checked={event.enabled}
                    onChange={() => toggleEventEnabled(event)}
                  />
                </td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {eventCreateDial && (
        <div className="create-event-dial">
          <div className="create-event-con">
            <div className="create-event-header">
              <h3
                style={{
                  backgroundColor: "transparent",
                  margin: "0px",
                  marginTop: "3px",
                  fontSize: "15px",
                }}
              >
                Create Event
              </h3>
            </div>
            <div className="create-event-content">
              <p className="creat-event-heading">Module:</p>
              <select
                className="event-module-dropdown"
                value={newEvent.module_table}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, module_table: e.target.value })
                }
              >
                <option value="">Select Module</option>
                {modules.map((module) => (
                  <option key={module.id} value={module.name}>
                    {module.name}
                  </option>
                ))}
              </select>

              <p className="creat-event-heading">Action:</p>
              <select
                value={newEvent.action}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, action: e.target.value })
                }
                className="event-module-dropdown"
              >
                <option value="">Select Action</option>
                <option value="creation">Creation</option>
                <option value="updation">Updation</option>
                <option value="deletion">Deletion</option>
              </select>

              <p className="creat-event-heading">Subject:</p>
              <input
                className="create-event-input"
                type="text"
                value={newEvent.subject}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, subject: e.target.value })
                }
              />

              <p className="creat-event-heading">Body:</p>
              <textarea
                className="create-event-textarea"
                value={newEvent.body}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, body: e.target.value })
                }
              />

              <p className="creat-event-heading">From Email:</p>
              <input
                className="create-event-input"
                type="email"
                value={newEvent.from_email}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, from_email: e.target.value })
                }
              />

              <p className="creat-event-heading">
                To Emails (comma-separated):
              </p>
              <input
                className="create-event-input"
                type="text"
                value={newEvent.to_emails}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, to_emails: e.target.value })
                }
              />

              <p className="creat-event-heading">Enabled:</p>
              <input
                className="cre-event-checkbox"
                type="checkbox"
                checked={newEvent.enabled}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, enabled: e.target.checked })
                }
              />
            </div>
            <div className="create-event-btn-con">
              <button className="create-event-btn" onClick={handleCreateEvent}>
                Create Event
              </button>
              <button
                className="cancel-event-btn"
                onClick={() => setEventCreateDial(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventSettings;
